import React from 'react';

import Label from 'components/_utility/Label';
import { getImageBaseUrl } from 'helpers/request';
import BikeFilters from 'src/components/BikeFilters/BikeFilters';

import { NotificationStripPortal } from 'components/NotificationStrip/NotificationStrip';
import {
  Outer,
  Container,
  ContentWrap,
  Title,
  ButtonWrapper,
  HeroButton,
  HeroImageWrapper,
  HeroLinkButton,
} from './Hero.styled';

import BackgroundImage from '../_utility/BackgroundImage/BackgroundImage';

const Hero = ({
  buttons = [],
  title,
  image,
  fluid,
  viewHidden,
  hasFilters,
  isFamilyPage = false,
  isGenrePage = false,
}) => (
  <>
    <NotificationStripPortal />
    <Outer>
      <Container hasFilters={hasFilters}>
        <HeroImageWrapper>
          {image ? (
            <BackgroundImage
              mobile={getImageBaseUrl() + image.srcSmall}
              tablet={getImageBaseUrl() + image.srcMedium}
              tabletLarge={getImageBaseUrl() + image.srcLarge}
              alt={image.alt}
            />
          ) : null}
        </HeroImageWrapper>
        <ContentWrap>
          <Title noMargin={buttons.length === 0}>{title}</Title>
          {buttons.length ? (
            <ButtonWrapper>
              {buttons.map(({ white = true, ...button }) =>
                button.to ? (
                  <HeroLinkButton to={button.to} key={button.id} whiteBackground={white}>
                    <Label name={button.label} />
                  </HeroLinkButton>
                ) : (
                  <HeroButton whiteBackground={white} key={button.id} onClick={button.onClick}>
                    <Label name={button.label} />
                  </HeroButton>
                )
              )}
            </ButtonWrapper>
          ) : null}
        </ContentWrap>
      </Container>
      <BikeFilters fluid={fluid} viewHidden={viewHidden} isFamilyPage={isFamilyPage} isGenrePage={isGenrePage} />
    </Outer>
  </>
);

export default Hero;
